import {AppActions} from '@ignitesales/neuro-application';
import {DialogueActions, DialogueActionsStorageKeys} from "./DialogueActions.mjs";
import {setColorsInDom, updatedDomColorsFromThemeSettings} from "../utils/colorHelper.mjs";

const dialogueReducer = (state, action) => {
    switch (action.type) {
        case AppActions.APP_READY: {
            const { themeSettings, themeManifest } = state;
            updatedDomColorsFromThemeSettings(themeManifest, themeSettings || {});
            return state;
        }

        case DialogueActions.THEME_CONFIGURATION_UPDATED: {
            return {
                ...state,
                themeSettings: action.themeSettings,
            };
        }

        case DialogueActions.THEME_DIALOGUE_GUIDE_SETTINGS_UPDATED: {
            return {
                ...state,
                dialogueGuideSettings: {
                    ...state.dialogueGuideSettings,
                    ...action.dialogueGuideSettings
                },
            };
        }

        case DialogueActions.CONTACT_PAGE_STATE_UPDATED: {
            return {
                ...state,
                contactPageIsActive: action.isActive
            }
        }

        case DialogueActions.CONTACT_PAGE_COMPLETED: {
            return {
                ...state,
                contactFormCompleted: true
            }
        }

        default:
            return state;
    }
};

export default dialogueReducer;
